import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { createAdjustmentEpic } from './_epics/createAdjustment.epic';
import { loadAdjustmentListEpic } from './_epics/loadAdjustmentList.epic';
import { updateAdjustmentEpic } from './_epics/updateAdjustment.epic';
import { removeAdjustmentEpic } from './_epics/removeAdjustment.epic';
import { exportAdjustmentProfileEpic } from './_epics/exportAdjustmentProfile.epic';

export const adjustmentProfileEpic = safeCombineEpics(
  createAdjustmentEpic,
  loadAdjustmentListEpic,
  updateAdjustmentEpic,
  removeAdjustmentEpic,
  exportAdjustmentProfileEpic,
);
